import { useChildComponent } from '@gogame/hooks-ts';
import { useScreenModalV2 } from '@gogame/screens';

import { useExportLinks } from 'scenes/Campaigns/GGCampaigns/data/mutations';

import CampaignsAddPromoCodeForm from '../CampaignsAddPromoCodeForm';
import { CAMPAIGN_IDS } from '../TrackingLinks/constants';
import {
  ACTION_ADD_ANOTHER,
  ACTION_ADD_PROMO_CODE,
  ACTION_DUPLICATE,
  ACTION_EXPORT_LINKS,
  CampaignCreatedSidePage,
} from './CampaignCreatedSidePage';

export const withCreateChaining =
  ({ CreateForm, DuplicateForm }) =>
  (BaseForm) =>
  ({ onSubmit, onClose, onExited, ...props }) => {
    const showCampaignCreatedSidePage = useScreenModalV2(
      CampaignCreatedSidePage
    );

    const [exportLinks] = useExportLinks();

    const handleSubmit = async ({ multiCampaign, campaigns }) => {
      const firstCampaign = campaigns?.[0];
      const exit = () => {
        onSubmit(firstCampaign);
        onExited();
      };
      try {
        let action = await showCampaignCreatedSidePage({
          initialCampaign: multiCampaign,
          campaigns: campaigns,
          onClose: exit,
        });

        switch (action) {
          case ACTION_EXPORT_LINKS:
            try {
              await exportLinks({
                [CAMPAIGN_IDS]: campaigns.map(({ id }) => id),
              });
            } catch (e) {
              /* eslint-disable-next-line */
              console.error('debug', e);
            } finally {
              exit();
            }
            break;
          case ACTION_ADD_PROMO_CODE:
            openChildComponent(CampaignsAddPromoCodeForm, {
              initialValues: {
                ids: campaigns.map(({ id }) => id),
                names: campaigns.map(({ name }) => name),
              },
              onExited: exit,
            });
            break;
          case ACTION_DUPLICATE:
            openChildComponent(DuplicateForm, {
              initialValues: multiCampaign,
              onSubmit: handleSubmit,
              onExited: (reason) => {
                if (reason === 'onClose') {
                  exit();
                }
              },
            });
            break;
          case ACTION_ADD_ANOTHER:
            openChildComponent(CreateForm, {
              ...props,
              onSubmit: handleSubmit,
              onExited: (reason) => {
                if (reason === 'onClose') {
                  exit();
                }
              },
            });
            break;
          default:
            /* eslint-disable-next-line */
            console.warn('Unknown action', action);
            break;
        }
      } catch (e) {
        exit();
      }
    };

    const [childComponent, openChildComponent] = useChildComponent(BaseForm, {
      ...props,
      onClose: onClose,
      onExited: (reason) => {
        if (reason === 'onClose') {
          onExited();
        }
      },
      onSubmit: handleSubmit,
    });

    return childComponent;
  };
